import script from "./ProjectItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectItem.vue?vue&type=script&setup=true&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=57f94801&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f94801"]])

export default __exports__